/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';

// 查询房源
const signinWithOAuth = async (data) => {
  const rst = await fetchPost('/web_oauth/signinWithOAuth', { data });
  return rst;
};


export {
  signinWithOAuth,
};
